import FiltersDataManager from './FiltersDataManager';
import useDataManager from './hooks/useDataManager';

const FiltersDataManagerProvider = ({ children, screen }) => {
  const {
    registerFilter,
    unregisterFilter,
    isFilterTouched,
    isFilterPending,
    isFilterDependsResolved,
    onFilterTouch,
    onFilterChange,
    onFilterLoad,
    onFilterResolve,
    allDependsPendingAwait,
  } = useDataManager();

  return (
    <FiltersDataManager.Provider
      value={{
        registerFilter,
        unregisterFilter,
        isFilterTouched,
        isFilterPending,
        isFilterDependsResolved,
        onFilterTouch,
        onFilterChange,
        onFilterLoad,
        onFilterResolve,
        allDependsPendingAwait,
        screen,
      }}
    >
      {children}
    </FiltersDataManager.Provider>
  );
};

export default FiltersDataManagerProvider;
